module.exports = __webpack_public_path__ + "resources/img/sp_intro2.25b417d7bed1f55d4144463f0c0eb314.png";